<ng-container *ngIf="data?.length; else emptyTable">
    <div class="data-block">
        <p-table
            [value]="data"
            [scrollable]="true"
            scrollHeight="flex"
            selectionMode="single"
            (onRowSelect)="onRowSelect($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th i18n>Статус</th>
                        <th i18n>Системный номер</th>
                        <th i18n>Номер документа</th>
                        <th i18n>Дата</th>
                        <th i18n>Отправитель</th>
                        <th i18n>Получатель
                        <th i18n>Наименование файла</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-doc>
                    <tr [pSelectableRow]="doc">
                        <td>{{ doc?.processingStatus?.name }}</td>
                        <td>{{ doc?.documentNumber }}</td>
                        <td>{{ doc?.edocumentNumber }}</td>
                        <td>{{ doc?.dateTime | date:'dd.MM.yyy' }}</td>
                        <td>{{ doc?.sender }}</td>
                        <td>{{ doc?.receiver }}</td>
                        <td>{{ doc?.fileName }}</td>
                    </tr>
                </ng-template>
        </p-table>
    </div>
</ng-container>
<ng-template #emptyTable>
    <div class="empty-table">
        <span>
            <ng-container *ngIf="!notFound; else notFoundData">
                <ng-container i18n>Для поиска введите системный номер, номер документа или наименование файла</ng-container>
            </ng-container>
            <ng-template i18n #notFoundData>
                По заданным параметрам документ не найден
            </ng-template>
        </span>
    </div>
</ng-template>